import { Controller } from "@hotwired/stimulus"

// Client-side search/filter for /problemas index.
export default class extends Controller {
  static targets = ["input", "item", "group", "empty"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const haystack = (item.dataset.search || "").toLowerCase()
      const show = query === "" || haystack.includes(query)
      item.hidden = !show
      if (show) visibleCount += 1
    })

    this.groupTargets.forEach((group) => {
      const hasVisible = group.querySelectorAll('[data-problem-index-target="item"]:not([hidden])').length > 0
      group.hidden = !hasVisible
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = visibleCount > 0
    }
  }
}
